import { FormShowType, Language, ReduxState, TextDirection } from 'interface';
import React, { CSSProperties, useEffect, useRef } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { __SLPLayoutContainer, __SLPLayoutRef } from './SLPLayout.interface';
import SLPQuestion, { QuestionSLPRef } from '../questions/questions.index';
import './SLPLayout.style.scss';
export interface SLPLayoutRef extends __SLPLayoutRef {}

const SLPLayout: React.ForwardRefRenderFunction<SLPLayoutRef, ConnectedProps<typeof connector> & __SLPLayoutContainer> =
    function (props: ConnectedProps<typeof connector> & __SLPLayoutContainer, ref) {
        const qRef = useRef<QuestionSLPRef>(null);
        const lang = props.language.SLP;
        const viewRef = useRef<HTMLDivElement>(null);
        const isSingle = props.form.show_type === FormShowType.single;
        const isFirstQuestion = props.questionIndex === 0;
        const isLastQuestion = props.questionIndex === props.questions[props.sectionIndex].length - 1;
        const isFirstPage = props.sectionIndex === 0;
        const isLastPage = props.sectionIndex === props.questions.length - 1;

        let counter = 1;
        for (let i = 0; i < props.questions.length; i++) {
            if (i < props.sectionIndex) counter += props.questions[i].length;
        }
        counter += props.questionIndex;

        const question = props.questions[props.sectionIndex][props.questionIndex];

        const section = props.form.sections.find((section) =>
            section.questions.map((question) => question.id).includes(question.id),
        );

        React.useImperativeHandle(ref, () => ({
            validate: (e?: boolean) => {
                console.log('now');
                if (!qRef.current) return false;
                return qRef.current.validate(e);
            },
            submit: (e?: boolean) => qRef.current?.submit(e),
            scrollToView: () => viewRef.current?.scrollIntoView(),
        }));

        return (
            <div dir={props.form.direction === TextDirection.ltr ? 'ltr' : 'rtl'} className={`ucheck-slp-layout`}>
                <div>
                    <div
                        className={`question-container ${isSingle ? 'single' : 'multi'} ${
                            isFirstQuestion ? 'first' : ''
                        }`}
                        ref={viewRef}
                    >
                        {!isSingle && isFirstQuestion && section ? <p className="page-title">{section.title}</p> : null}
                        <SLPQuestion
                            answerList={props.answerList}
                            setAnswerList={props.setAnswerList}
                            answer={props.answer}
                            submit={props.submit}
                            ref={qRef}
                            question={question}
                            form={props.form}
                            next={props.next}
                            counter={props.form.question_counter ? counter : undefined}
                        />
                    </div>
                    {isSingle || isLastQuestion ? (
                        <div className="wizard-control-container" style={{ backgroundColor: props.form.footer_color }}>
                            {isSingle && !isFirstQuestion ? (
                                <div style={{ color: props.form.button_label_color }} onClick={() => props.previous()}>
                                    <i className="material-icons">
                                        {props.form.direction === TextDirection.rtl ? 'east' : 'west'}
                                    </i>
                                    <span>
                                        {props.form.previous_button
                                            ? props.form.previous_button
                                            : props.form.lang === Language.fa
                                            ? lang.previous
                                            : lang.previousEN}
                                    </span>
                                </div>
                            ) : null}
                            {!isSingle && !isFirstPage ? (
                                <div
                                    style={{ color: props.form.button_label_color }}
                                    onClick={() => props.previous(true)}
                                >
                                    <i className="material-icons">
                                        {props.form.direction === TextDirection.rtl ? 'east' : 'west'}
                                    </i>
                                    <span>
                                        {props.form.lang === Language.fa ? lang.previousPage : lang.previousPageEN}
                                    </span>
                                </div>
                            ) : null}
                            {(isSingle && isFirstQuestion) || (!isSingle && isFirstPage) ? (
                                <div
                                    onClick={() => {
                                        if (props.cancel) props.cancel();
                                    }}
                                >
                                    {props.form.lang === Language.fa ? lang.cancel : lang.cancelEN}
                                </div>
                            ) : null}
                            {(isSingle && isFirstQuestion) || (!isSingle && isFirstPage) ? <div /> : null}
                            {isSingle && !isLastQuestion ? (
                                <div onClick={props.next} style={{ color: props.form.button_label_color }}>
                                    <span>
                                        {props.form.next_button
                                            ? props.form.next_button
                                            : props.form.lang === Language.fa
                                            ? lang.next
                                            : lang.nextEN}
                                    </span>
                                    <i className="material-icons">
                                        {props.form.direction === TextDirection.rtl ? 'west' : 'east'}
                                    </i>
                                </div>
                            ) : null}
                            {(isSingle && isLastQuestion) || (!isSingle && isLastQuestion && isLastPage) ? (
                                <div onClick={props.next} style={{ color: props.form.button_label_color }}>
                                    <span>
                                        {props.form.end_button && props.form.end_button.length > 0
                                            ? props.form.end_button
                                            : props.form.lang === Language.fa
                                            ? lang.finish
                                            : lang.finishEN}
                                    </span>
                                    <i className="material-icons">check_circle_outline</i>
                                </div>
                            ) : null}
                            {!isSingle && isLastQuestion && !isLastPage ? (
                                <div onClick={props.next} style={{ color: props.form.button_label_color }}>
                                    <span>{props.form.lang === Language.fa ? lang.nextPage : lang.nextPageEN}</span>
                                    <i className="material-icons">
                                        {props.form.direction === TextDirection.rtl ? 'west' : 'east'}
                                    </i>
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>
        );
    };

const mapStateToProps = (state: ReduxState) => ({
    // direction: state.direction,
    // data: state.SLP,
    language: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPLayout));
